import { render, staticRenderFns } from "./viewStaff.vue?vue&type=template&id=748956db&scoped=true&"
import script from "./viewStaff.vue?vue&type=script&lang=js&"
export * from "./viewStaff.vue?vue&type=script&lang=js&"
import style0 from "./viewStaff.vue?vue&type=style&index=0&id=748956db&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748956db",
  null
  
)

export default component.exports